import { DISABLED_LAYOUT_VIEWPORT_WIDTH, RESPONSIVE_LAYOUT_ENABLED } from '@/theme/breakpoints'

const RESPONSIVE_VIEWPORT = 'width=device-width, initial-scale=1.0, viewport-fit=cover'
const DESKTOP_VIEWPORT = `width=${DISABLED_LAYOUT_VIEWPORT_WIDTH}, viewport-fit=cover`

/**
 * While responsive layouts are disabled the viewport is pinned to a desktop width, so phones
 * and tablets scale the desktop shell down instead of laying it out at device width — at device
 * width the fixed header and filter bar fall outside an `overflow:hidden` shell and become
 * unreachable. Zoom stays enabled.
 *
 * index.html ships the pinned value so nothing depends on this running; re-enabling the flag
 * restores the responsive viewport here, before the root renders.
 */
export function applyViewportPolicy() {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]')
  if (!meta) return

  meta.content = RESPONSIVE_LAYOUT_ENABLED ? RESPONSIVE_VIEWPORT : DESKTOP_VIEWPORT
}
